


{
  "familyId": "STU-INHOUDSOPGAVE",
  "questions": [
    {
      "id": "STU-INHOUDSOPGAVE-001",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Sara wil weten op welke pagina ze kan lezen over vulkanen. Welk deel van het boek helpt haar het snelst?",
      "options": [
        "De inhoudsopgave hierboven — die toont onderwerpen met paginanummers.",
        "De woordenlijst achterin het boek.",
        "De naam van de schrijver op de voorkant.",
        "De flaptekst op de achterkant."
      ],
      "correctAnswer": 0,
      "context": "Functioneel doel van een inhoudsopgave (met stimulus)",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.inhoud-woordenlijst-verward", "label": "Verwart inhoudsopgave met woordenlijst", "optionIndex": 1 },
          { "id": "stu.inhoud-auteursinfo-verwacht", "label": "Denkt dat schrijver-info in inhoudsopgave staat", "optionIndex": 2 },
          { "id": "stu.inhoud-flaptekst-verward", "label": "Verwart inhoudsopgave met flaptekst", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "tableOfContents",
          "showWhen": "always",
          "data": {
            "bookTitle": "De Aarde in Beweging",
            "entries": [
              { "number": "1", "title": "Onze planeet", "page": 4 },
              { "number": "2", "title": "Aardlagen", "page": 12 },
              { "number": "3", "title": "Vulkanen", "page": 20, "highlight": true },
              { "number": "4", "title": "Aardbevingen", "page": 28 },
              { "number": "5", "title": "Bergen en dalen", "page": 36 }
            ],
            "label": "Inhoudsopgave"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wat doet een inhoudsopgave?",
            "content": "De inhoudsopgave toont alle hoofdstukken + paginanummers. Wil je een onderwerp opzoeken? Kijk hier — niet op de kaft of achterflap.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoudsopgave_doel_functioneel",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Sara ziet meteen in de inhoudsopgave dat 'Vulkanen' op pagina 20 begint. Daarvoor is een inhoudsopgave gemaakt: onderwerp → paginanummer.",
        "solutionSteps": [
          "1. Sara zoekt een onderwerp ('vulkanen')",
          "2. Inhoudsopgave bevat onderwerpen + paginanummers",
          "3. 'Vulkanen' staat op pagina 20",
          "4. Sneller dan bladeren of voorkant lezen"
        ],
        "distractorExplanations": {
          "0": "Goed! De inhoudsopgave wijst direct naar pagina 20 — geen gezoek nodig.",
          "1": "Een woordenlijst legt moeilijke woorden uit. Dat helpt niet om een hoofdstuk te vinden.",
          "2": "De schrijver staat op de voorkant — die zegt niets over paginanummers.",
          "3": "De flaptekst geeft een korte samenvatting, geen pagina-overzicht."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-002",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Op welke pagina begint het hoofdstuk over planten?",
      "options": ["Pagina 12", "Pagina 4", "Pagina 20", "Pagina 2"],
      "correctAnswer": 0,
      "context": "Inhoudsopgave aflezen",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "stu.inhoud-verkeerd-hoofdstuk", "label": "Pakt paginanummer van verkeerd hoofdstuk", "optionIndex": 1 },
          { "id": "stu.inhoud-aangrenzend-hoofdstuk", "label": "Pakt paginanummer van verkeerd hoofdstuk", "optionIndex": 2 },
          { "id": "stu.inhoud-paginanummer-verzonnen", "label": "Verzint paginanummer", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "tableOfContents",
          "showWhen": "always",
          "data": {
            "bookTitle": "De Jungle",
            "title": "Inhoudsopgave",
            "entries": [
              { "number": "1", "title": "Dieren in de jungle", "page": 4 },
              { "number": "2", "title": "Planten in de jungle", "page": 12 },
              { "number": "3", "title": "Het klimaat", "page": 20 }
            ]
          }
        }
      ],
      "supportAids": [
        {
          "type": "tableOfContents",
          "showWhen": "wrong",
          "data": {
            "bookTitle": "De Jungle",
            "title": "Inhoudsopgave",
            "entries": [
              { "number": "1", "title": "Dieren in de jungle", "page": 4 },
              { "number": "2", "title": "Planten in de jungle", "page": 12, "highlight": true },
              { "number": "3", "title": "Het klimaat", "page": 20 }
            ]
          }
        }
      ],
      "conceptId": "inhoudsopgave_paginanummer",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Zoek 'planten' in de inhoudsopgave → Hoofdstuk 2: Planten in de jungle, pagina 12.",
        "solutionSteps": [
          "Zoek het onderwerp 'planten'",
          "Gevonden: Hoofdstuk 2",
          "Lees het paginanummer: 12"
        ],
        "distractorExplanations": {
          "0": "Goed! Hoofdstuk 2 over planten begint op pagina 12.",
          "1": "Pagina 4 is van Hoofdstuk 1 (Dieren).",
          "2": "Pagina 20 is van Hoofdstuk 3 (Klimaat).",
          "3": "Pagina 2 staat niet in deze inhoudsopgave."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-003",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Hoeveel pagina's telt hoofdstuk 2 (van pagina 8 tot het begin van hoofdstuk 3)?",
      "options": ["7 pagina's", "8 pagina's", "15 pagina's", "6 pagina's"],
      "correctAnswer": 0,
      "context": "Hoofdstuklengte berekenen",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.inhoud-startpagina-als-lengte", "label": "Geeft startpagina als hoofdstuklengte", "optionIndex": 1 },
          { "id": "stu.inhoud-volgende-start-als-lengte", "label": "Geeft startpagina van volgend hoofdstuk", "optionIndex": 2 },
          { "id": "stu.inhoud-off-by-one", "label": "Off-by-one fout", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "tableOfContents",
          "showWhen": "always",
          "data": {
            "bookTitle": "De Middeleeuwen",
            "title": "Inhoudsopgave",
            "entries": [
              { "number": "1", "title": "De Middeleeuwen", "page": 3 },
              { "number": "2", "title": "Ridders en kastelen", "page": 8 },
              { "number": "3", "title": "Het dagelijks leven", "page": 15 },
              { "number": "4", "title": "Het einde van de Middeleeuwen", "page": 22 }
            ]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoofdstuklengte berekenen",
            "content": "Hoofdstuk 2 begint op pagina 8, hoofdstuk 3 begint op pagina 15. Aantal pagina's = 15 − 8 = 7.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoudsopgave_paginas_tellen",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Hoofdstuk 2 loopt van pagina 8 t/m 14 (want hoofdstuk 3 begint op 15). Dat zijn 15 − 8 = 7 pagina's.",
        "solutionSteps": [
          "Hoofdstuk 2 begint op pagina 8",
          "Hoofdstuk 3 begint op pagina 15",
          "Aantal pagina's = 15 − 8 = 7",
          "Check: 8, 9, 10, 11, 12, 13, 14 = 7 pagina's ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 15 − 8 = 7 pagina's.",
          "1": "8 is de startpagina, niet de lengte. Bereken: 15 − 8 = 7.",
          "2": "15 is waar hoofdstuk 3 begint. De LENGTE van hoofdstuk 2 is 15 − 8 = 7.",
          "3": "15 − 8 = 7, niet 6. Tel maar na: 8, 9, 10, 11, 12, 13, 14 = 7 pagina's."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-004",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Waar in een boek vind je de inhoudsopgave?",
      "options": [
        "Voorin het boek, na de titelpagina",
        "Achterin het boek, na het laatste hoofdstuk",
        "In het midden van het boek",
        "Op de achterflap van het boek"
      ],
      "correctAnswer": 0,
      "context": "Plaats van de inhoudsopgave",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "stu.inhoud-register-verward", "label": "Verwart inhoudsopgave met register (index)", "optionIndex": 1 },
          { "id": "stu.inhoud-midden-verwacht", "label": "Plaatst inhoudsopgave in het midden", "optionIndex": 2 },
          { "id": "stu.inhoud-flaptekst-geconsulteerd", "label": "Verwart met flaptekst", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Waar staat de inhoudsopgave?",
            "content": "Voorin het boek, vlak na de titelpagina. Een register (alfabetische index) staat juist achterin.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoudsopgave_locatie",
      "variantIndex": 4,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "De inhoudsopgave staat altijd voorin, vlak na de titelpagina. Zo zie je meteen wat er in het boek staat.",
        "solutionSteps": [
          "Inhoudsopgave = voorin (na titelpagina)",
          "Register/index = achterin (alfabetisch)",
          "Flaptekst = op de achterflap (samenvatting)"
        ],
        "distractorExplanations": {
          "0": "Goed! Voorin het boek.",
          "1": "Achterin staat het register (alfabetische index), niet de inhoudsopgave.",
          "2": "In het midden staan gewoon de hoofdstukken zelf.",
          "3": "De achterflap heeft een korte samenvatting, geen paginanummers."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-005",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Je wilt iets weten over 'vulkanen'. Je hebt een boek over de aarde. Wat doe je als eerste?",
      "options": [
        "Kijk in de inhoudsopgave of er een hoofdstuk over vulkanen is.",
        "Begin het boek van voren af aan te lezen.",
        "Sla het boek willekeurig open.",
        "Lees de achterflap."
      ],
      "correctAnswer": 0,
      "context": "Slim zoeken in een non-fictie boek",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.inhoud-hele-boek-doorlezen", "label": "Leest het hele boek door", "optionIndex": 1 },
          { "id": "stu.inhoud-willekeurig-bladeren", "label": "Bladert willekeurig", "optionIndex": 2 },
          { "id": "stu.inhoud-flaptekst-als-eerste", "label": "Begint bij flaptekst", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Slim zoeken",
            "content": "Bij een gericht onderwerp: kijk eerst in de inhoudsopgave. Daar zie je meteen of er een hoofdstuk over staat — en op welke pagina.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoudsopgave_strategie",
      "variantIndex": 5,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De inhoudsopgave is het snelste hulpmiddel om gericht iets op te zoeken. Open het boek voorin → zoek 'vulkanen' → lees het paginanummer → blader erheen.",
        "solutionSteps": [
          "Open boek voorin",
          "Zoek in de inhoudsopgave naar 'vulkanen'",
          "Lees paginanummer af",
          "Blader naar die pagina"
        ],
        "distractorExplanations": {
          "0": "Goed! De inhoudsopgave bespaart tijd.",
          "1": "Het hele boek lezen kost veel te veel tijd voor één onderwerp.",
          "2": "Willekeurig bladeren is niet efficiënt — je vindt het toevallig of helemaal niet.",
          "3": "De achterflap geeft een algemene beschrijving, geen paginanummers van onderwerpen."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-006",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "matching",
      "question": "Koppel elk onderwerp aan het juiste hoofdstuk van het boek 'Het menselijk lichaam'.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "Hoe je hart klopt", "right": "Hoofdstuk 2: Bloedsomloop" },
          { "left": "Wat er gebeurt na een hap brood", "right": "Hoofdstuk 3: Spijsvertering" },
          { "left": "Hoe spieren werken", "right": "Hoofdstuk 4: Bewegen" },
          { "left": "Wat oren en ogen doen", "right": "Hoofdstuk 5: Zintuigen" }
        ]
      },
      "context": "Onderwerp → hoofdstuk in een inhoudsopgave",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "tableOfContents",
          "showWhen": "always",
          "data": {
            "bookTitle": "Het menselijk lichaam",
            "title": "Inhoudsopgave",
            "entries": [
              { "number": "1", "title": "Inleiding", "page": 3 },
              { "number": "2", "title": "Bloedsomloop", "page": 9 },
              { "number": "3", "title": "Spijsvertering", "page": 18 },
              { "number": "4", "title": "Bewegen", "page": 26 },
              { "number": "5", "title": "Zintuigen", "page": 34 }
            ]
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Onderwerp → hoofdstuk",
            "content": "Bedenk waar elk onderwerp bij hoort: hart = bloedsomloop, eten = spijsvertering, spieren = bewegen, oog/oor = zintuigen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoudsopgave_match",
      "variantIndex": 6,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Elk onderwerp valt onder een groter thema. Hartritme → bloedsomloop. Vertering van eten → spijsvertering. Spierwerking → bewegen. Oren/ogen → zintuigen. Zo gebruik je een inhoudsopgave: van detail naar hoofdstuk.",
        "solutionSteps": [
          "Hart klopt → bloedsomloop (Hoofdstuk 2)",
          "Hap brood → spijsvertering (Hoofdstuk 3)",
          "Spieren → bewegen (Hoofdstuk 4)",
          "Oren/ogen → zintuigen (Hoofdstuk 5)"
        ]
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-007",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "ordering",
      "question": "De volgorde van deze hoofdstukken is door elkaar geraakt. Zet ze terug in de juiste volgorde (laagste paginanummer eerst).",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Hoofdstuk 1: Inleiding (pag. 3)",
          "Hoofdstuk 2: Bloedsomloop (pag. 9)",
          "Hoofdstuk 3: Spijsvertering (pag. 18)",
          "Hoofdstuk 4: Bewegen (pag. 26)",
          "Hoofdstuk 5: Zintuigen (pag. 34)"
        ],
        "correctOrder": [0, 1, 2, 3, 4]
      },
      "context": "Inhoudsopgave herstellen",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Volgorde van hoofdstukken",
            "content": "Hoofdstukken staan op volgorde van paginanummer: laagste eerst. 3 < 9 < 18 < 26 < 34.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "inhoudsopgave_volgorde",
      "variantIndex": 7,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Inhoudsopgaven zijn altijd in dezelfde volgorde als het boek: laagste paginanummer eerst. 3 → 9 → 18 → 26 → 34.",
        "solutionSteps": [
          "Vergelijk paginanummers: 3, 9, 18, 26, 34",
          "Sorteer van laag naar hoog",
          "Volgorde: Inleiding → Bloedsomloop → Spijsvertering → Bewegen → Zintuigen"
        ]
      }
    }
  ]
}


